





































































































































































































import { UserScheduledQuery, UserScheduledQuerySubscription } from '@/interfaces/scheduled-query'
import ScheduledQueryModifyModal from '@/components/helper-components/scheduled-query/ScheduledQueryModifyModal.vue'
import ScheduledQuerySubscriptionModifyModal from '@/components/helper-components/scheduled-query/ScheduledQuerySubscriptionModifyModal.vue'
import QueryPreview from '@/components/helper-components/QueryPreview.vue'
import CustomModal from '@/components/helper-components/CustomModal.vue'
import { customModalMixin } from '@/mixins/customModalMixin'
import { WARNING } from '@/constants/buttons'
import { User } from '@/interfaces/user'

import { mapState } from 'vuex'
import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'

export default Vue.extend({
  components: {
    ScheduledQueryModifyModal,
    ScheduledQuerySubscriptionModifyModal,
    QueryPreview,
    CustomModal
  },

  mixins: [
    customModalMixin
  ],

  props: {
    scrollEdgeDistances: Array,
    queryPanelWidth: Number
  },

  data () {
    return {
      showModifyScheduledQueryModal: false,
      showModifyScheduledQuerySubscriptionModal: false,
      toDeleteSubscription: {
        scheduledId: -1
      },
      toDeleteScheduledQuery: {
        scheduledId: -1
      },
      toModifyScheduledQuery: {
        id: -1,
        name: '',
        schedule: '',
        recurrence: 'Daily',
        day: new Date().getDay(),
        hourAndMinute: '00:00',
        text: '',
        emailSubscribers: [] as Number[],
        slackSubscribers: [] as Number[],
        hasResults: false
      },
      toModifyScheduledQuerySubscription: {},
      queryPreviewData: {
        title: 'Query Preview',
        isQuery: true,
        content: {},
        width: 632,
        height: 300,
        horizontalPosition: '',
        horizontalOffset: this.queryPanelWidth - 40,
        referredTopPosition: 0,
        show: false
      },
      user: this.$auth.getUser(),
      onFocusChildDom: ''
    }
  },

  computed: {
    ...mapState('scheduledQuery', {
      scheduledQueryLoading: 'scheduledQueryLoading',
      scheduledQuerySubscriptionLoading: 'scheduledQuerySubscriptionLoading',
      scheduledQueries: 'scheduledQueries',
      scheduledQueriesSubscriptions: 'scheduledQueriesSubscriptions'
    }),

    hasScheduledQuery (): Boolean {
      return !_.isEmpty(this.scheduledQueries)
    },

    hasSubscription (): Boolean {
      return !_.isEmpty(this.scheduledQueriesSubscriptions)
    }
  },

  watch: {
    queryPanelWidth () {
      this.$set(this.queryPreviewData, 'horizontalOffset', this.queryPanelWidth - 40)
    }
  },

  methods: {
    getQueryNameFromPath (path: string) {
      const parts = path.split('/')
      return parts.length ? parts[parts.length - 1] : 'Query Preview'
    },

    getNotificationType (types: string[]): string {
      return types.join(', ')
    },

    /**
     * Returns recurrence as hourly daily or weekly based on the cron string input
     * @param {String} schedule
     * @return {String} recurrence
     */
    getRecurrence (schedule: string): string {
      if (!schedule) {
        return ''
      }
      const scheduleElements = schedule.split(' ')
      const hour = scheduleElements[1]
      const dayOfWeek = scheduleElements[4]

      let recurrence = 'Hourly'

      if (hour !== '*') {
        recurrence = 'Daily'
      }
      if (dayOfWeek !== '*') {
        recurrence = 'Weekly'
      }

      return recurrence
    },

    /**
     * Open new tab that shows the latest result of this scheduled query
     * @param {Object} scheduledQuery
     */
    async openScheduledQueryRuns (scheduledQuery: UserScheduledQuery): Promise<void> {
      try {
        const response = await axios.get(process.env.VUE_APP_API_URI + '/scheduled-queries/' + scheduledQuery.scheduledId + '/latest')
        window.open('/scheduled-query/' + response.data)
      } catch (error) {
        this.$Message.error(`Error viewing scheduled query runs: ${error.response.data.error}`)
      }
    },

    readSchedule (schedule: string): { day: number, hourAndMinute: string, recurrence: string } {
      const scheduleElements = schedule.split(' ')
      const minute = parseInt(scheduleElements[0]) < 10 ? `0${scheduleElements[0]}` : scheduleElements[0]
      const hour = scheduleElements[1]
      const hourOffset = new Date().getTimezoneOffset() / 60 // how many hours behind UTC your local timezone is
      const forwardOneDay = (parseInt(hour) - hourOffset > 24)
      const backOneDay = (parseInt(hour) - hourOffset < 0)

      // adjust hour value based on timezone vs utc
      let localHour = hour
      let dayOfWeek = scheduleElements[4]
      let day = parseInt(dayOfWeek)
      let recurrence = 'Hourly'
      if (hour !== '*') {
        recurrence = 'Daily'
        const localHourNum = (((parseInt(hour) - hourOffset) % 24) + 24) % 24
        localHour = localHourNum < 10 ? `0${localHourNum}` : `${localHourNum}`
      }
      if (dayOfWeek !== '*') {
        let dayOfWeekNum = parseInt(dayOfWeek)
        recurrence = 'Weekly'
        if (forwardOneDay) {
          dayOfWeekNum++
        }
        if (backOneDay) {
          dayOfWeekNum--
        }
        day = (((dayOfWeekNum % 7) + 7) % 7)
      }
      const hourAndMinute = `${localHour === '*' ? '00' : localHour}:${minute}`
      return {
        day,
        hourAndMinute,
        recurrence
      }
    },

    /**
     * Open modify scheduled query modal and populate model based on the scheduled query context. Will convert UTC
     * time from server to local time for visualization.
     * @param {Object} scheduledQuery
     * @param {Number} scheduledQueryId
     */
    openModifyScheduledQuery (scheduledQuery: UserScheduledQuery, scheduledQueryId: number): void {
      this.showModifyScheduledQueryModal = true
      const { name, text, schedule, emailSubscribers, slackSubscribers } = scheduledQuery

      const { day, hourAndMinute, recurrence } = this.readSchedule(schedule)
      // mapping of js string to conditions is brittle
      const hasResults = scheduledQuery.conditional === 'results.length > 0'
      const id = scheduledQueryId

      this.toModifyScheduledQuery = { ...this.toModifyScheduledQuery, id, name, text, day, hourAndMinute, recurrence, emailSubscribers, slackSubscribers, hasResults }
    },

    closeScheduledQueryModifyModal (): void {
      this.showModifyScheduledQueryModal = false
      this.resetModifyScheduledQueryForm()
    },

    resetModifyScheduledQueryForm (): void {
      this.toModifyScheduledQuery = {
        id: -1,
        name: '',
        schedule: '',
        recurrence: 'Daily',
        day: new Date().getDay(),
        hourAndMinute: '00:00',
        text: '',
        emailSubscribers: [],
        slackSubscribers: [],
        hasResults: false
      }
    },

    openModifySubscription (subscription: UserScheduledQuerySubscription) {
      this.showModifyScheduledQuerySubscriptionModal = true
      // TODO: later move readSchedule into helpers, and move the data confign logic of both query/subscription into their modify modal components
      const { schedule, types, authorEmail, conditional, scheduledId } = subscription
      const { day, hourAndMinute, recurrence } = this.readSchedule(schedule)
      const hasResults = conditional === 'results.length > 0'
      const notifyEmail = types.includes('email')
      const notifySlack = types.includes('slack')

      this.toModifyScheduledQuerySubscription = {
        ...this.toModifyScheduledQuerySubscription,
        scheduledId,
        day,
        hourAndMinute,
        recurrence,
        authorEmail,
        hasResults,
        notifySlack,
        notifyEmail,
        types
      }
    },

    closeScheduledQuerySubscriptionModifyModal (): void {
      this.showModifyScheduledQuerySubscriptionModal = false
    },

    /**
     * Open delete scheduled query modal and populate model based on the scheduled query context
     * @param {Object} scheduledQuery
     */
    openDeleteScheduledQuery (scheduledQuery: UserScheduledQuery): void {
      this.toDeleteScheduledQuery = scheduledQuery
      this.onDeleteScheduledQuery()
    },

    closeDeleteModal (): void {
      this.toDeleteScheduledQuery = {
        scheduledId: -1
      }
    },

    updateQueryPreviewData (event: Object): void {
      this.queryPreviewData = {
        ...this.queryPreviewData,
        ...event
      }
    },

    /**
     * Function used to update top for the query preview window
     */
    updatePreviewreferredTop (newTop: number): void {
      this.$set(this.queryPreviewData, 'referredTopPosition', newTop)
    },

    /**
     * Update the props passed to the query preview to update the view
     * @param {Boolean} showPreview      If "TRUE", displays the query preview. Otherwise, hides the query preview.
     * @param {Object} queryObject       It contains query properties (id, queryText, isLibrary, queryName).
     * @param {Object} parentDomName  name of upper dom object, used for calculate top value (relative -> absolute)
     * @param {Array} childDomName name of a list of child doms that the QueryPreview renders on
     */
    onUpdatePreviewProps (showPreview: Boolean, queryObject: { queryText: string, queryName: string }, parentDomName: string, childDomName: string): void {
      this.onFocusChildDom = childDomName
      const show = showPreview
      let dataParam = {}
      if (showPreview) {
        const parentDom = this.$refs[parentDomName]
        const childDomArr = this.$refs[childDomName]
        // @ts-ignore, error for not finding getBoundingClientRect in Vue
        const parentTop = parentDom ? parentDom.getBoundingClientRect().top : 0
        if (childDomArr) {
          // @ts-ignore, error for childDomArr type
          const newTop = childDomArr[0].getBoundingClientRect().top - parentTop
          this.updatePreviewreferredTop(newTop)
        }
        const isEnoughHeight = this.queryPreviewData.referredTopPosition + this.queryPreviewData.height + parentTop < window.innerHeight

        // Construct the updated queryPreviewDta
        // title, isQuery is static, not changed here
        let horizontalPosition = ''
        let top = this.queryPreviewData.referredTopPosition
        let height = this.queryPreviewData.height
        const isQuery = this.queryPreviewData.isQuery
        const title = queryObject.queryName

        if (isEnoughHeight || (!isEnoughHeight && top < height)) {
          horizontalPosition = 'right-start'
        } else {
          horizontalPosition = 'right-end'
          top = top - height - (isQuery ? 32 : 24)
        }

        height = isQuery ? 300 : 112
        const queryText = isQuery && queryObject && queryObject.hasOwnProperty('queryText') ? queryObject.queryText : ''
        const content = { ...this.queryPreviewData.content, queryText }

        dataParam = { referredTopPosition: top, height, horizontalPosition, show, isQuery, content, title }
      } else {
        dataParam = { show }
      }
      this.updateQueryPreviewData(dataParam)
    },

    async onDeleteScheduledQuery () {
      let message = `<p>Are you sure you want to delete this scheduled query?</p>`
      let callback = this.deleteScheduledQuery.bind(this)
      const results = (await axios.get(`${process.env.VUE_APP_API_URI}/scheduled-queries/${this.toDeleteScheduledQuery.scheduledId}/subscriptions/users`)).data
      const affectedUsers: User[] = results.filter((result: User) => result.id && result.id !== this.user.id)
      if (affectedUsers.length) {
        message += `<p>The following users who subscribed to the query would be affected:</p>`
        affectedUsers.forEach(user => {
          message += `<p>- ${user.email}</p>`
        })
      }
      const errorMessage = {
        title: 'Delete Scheduled Query',
        icon: 'fas fa-trash',
        category: 'custom',
        message,
        actionButtons: [
          {
            label: 'Confirm',
            type: WARNING,
            callback
          }
        ],
        cancelButton: {
          label: 'Cancel'
        }
      }
      // @ts-ignore
      this.showModalMixin(errorMessage)
    },

    async openDeleteSubscription (query: any) {
      let message = `
        <p>Are you sure you want to delete this subscription?</p>
        <p><span style="font-weight:bold;margin-top:10px;">Name: </span>${query.name}</p>
        <p><span style="font-weight:bold;">Frequency: </span>${this.getRecurrence(query.schedule)}</p>
        <p><span style="font-weight:bold;">Created by: </span>${query.authorEmail}</p>
        <p><span style="font-weight:bold;">Notificaton: </span>${this.getNotificationType(query.types)}</p>
      `
      let callback = this.deleteScheduledQuerySubscription.bind(this)
      this.toDeleteSubscription.scheduledId = query.scheduledId
      const warningMessage = {
        title: 'Delete Scheduled Query Subscription',
        icon: 'fas fa-trash',
        category: 'custom',
        message,
        actionButtons: [
          {
            label: 'Confirm',
            type: WARNING,
            callback
          }
        ],
        cancelButton: {
          label: 'Cancel'
        }
      }
      // @ts-ignore
      this.showModalMixin(warningMessage)
    },

    /**
     * Closes the action window (modal).
     * if all actions can be taken care of as callback functions in the CustomModal
     * TODO: can handle this closeModal totally in the CustomModal component
     */
    closeActionWindow () {
      // @ts-ignore
      this.hideModalMixin()
    },

    /**
     * After confirmation, delete the scheduled query.
     */
    async deleteScheduledQuery () {
      try {
        await axios({
          method: 'delete',
          url: process.env.VUE_APP_API_URI + '/scheduled-queries/' + this.toDeleteScheduledQuery.scheduledId
        })
        this.$store.dispatch('scheduledQuery/onLoadScheduledQueries', this.user.id)
        this.$store.dispatch('scheduledQuery/onLoadScheduledQueriesSubscriptions', this.user.id)
      } catch (error) {
        this.$Message.error(`Error deleting scheduled query: ${error}`)
        console.error(`Error deleting scheduled query: ${error}`)
      } finally {
        this.closeActionWindow()
      }
    },

    async deleteScheduledQuerySubscription () {
      try {
        await axios.delete(`${process.env.VUE_APP_API_URI}/scheduled-queries/subscriptions`, {
          params: {
            scheduledId: this.toDeleteSubscription.scheduledId,
            userId: this.user.id
          }
        })
        this.$store.dispatch('scheduledQuery/onLoadScheduledQueriesSubscriptions', this.user.id)
        this.$store.dispatch('scheduledQuery/onLoadScheduledQueries', this.user.id)
      } catch (error) {
        console.error(`Fail to delete scheduled query subscription: ${error}`)
        this.$Message.error(`Fail to delete scheduled query subscription: ${error}`)
      } finally {
        this.closeActionWindow()
      }
    }
  }
})
